import axios from '~/common/plugins/axios.js'
export const state = () => ({
  columnDetailobj: { column_id: '', shop_id: '', name: '' }, //当前栏目
  adBroadMap: {}, // 广告播放数据
  adContDetaList: [], // 内容详情页 广告
  adContDisplaypageList: [], // 展示页 广告
  platformShop: { id: '', name: '' }, //平台商户
  userId: '', //用户id
  isLogin: false, //登录凭证，login.loginFlag这个获取太慢了
  contentDetail: { content_id: '' }, //内容详情页面的内容详情
  isGuest: false, //登录了，以游客身份登录
  changeNav: 0
});

export const mutations = {
  set_column_detail(state, v) {
    state.columnDetailobj = v;
  },
  set_platform_shop(state, v) {
    state.platformShop = v;
  },
  setAdBroadMap(state, v) {
    // 存放广告播放数据
    state.adBroadMap = v;
  },
  setAdContDetaList(state, v) {
    // 存放内容详情页 广告
    state.adContDetaList = v;
  },
  setAdContDisplayList(state, v) {
    // 存放展示页 广告
    state.adContDisplaypageList = v;
  },
  setUserId(state, v) {
    state.userId = v;
  },
  setIsLogin(state, v) {
    state.isLogin = v;
  },
  setContentDetail(state, v) {
    state.contentDetail = v;
  },
  setIsGuest(state, v) {
    state.isGuest = v;
  },
  setChangeNav(state) {
    state.changeNav++;
  },
};

export const actions = {};
export default {
	namespaced: true,
	state,
	actions,
	mutations
}